import styled from 'styled-components';

export const StyledHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.token.next.colorBorder};
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
`;

export const StyledBody = styled.div`
  padding: 16px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledFooter = styled.div`
  padding: 16px;
  border-top: 1px solid ${({ theme }) => theme.token.next.colorBorder};
  display: flex;
  justify-content: flex-end;
`;
